import { AuditEntity } from "@app/common";
import { Column, Display, Table } from "@messaia/cdk";
import { WorklistStatus } from "../enums/worklist-status";

@Table({
	endpoint: 'worklist',
	includes: ['Client', 'Customer'],
	addable: false,
	editable: false,
	deletable: false,
	selectable: false,
	rowNgClass: (row: Worklist) => {
		return {
			'succeeded': row.status == WorklistStatus.Done,
			'warn': row.status == WorklistStatus.InProcess,
			'error': row.status == WorklistStatus.Active,
			'cancelled': row.status == WorklistStatus.Ignore,
		};
	},
})
export class Worklist extends AuditEntity {
	@Column({ contentLength: 80, tooltip: (row: Worklist) => row.errorMessage })
	@Display($localize`:@@message:Message`)
	errorMessage: string;

	@Column({ showGtMd: true, maxWidth: 75 })
	@Display($localize`:@@errorCode:Error code`)
	errorCode: string;

	@Column({
		enumType: WorklistStatus,
		maxWidth: 95,
		showGtMd: true,
		cellNgClass: (row: Worklist) => {
			return {
				'tc-orange-500': row.status == WorklistStatus.InProcess,
				'tc-green-500': row.status == WorklistStatus.Done,
				'tc-black': row.status == WorklistStatus.Ignore,
				'tc-red-500': row.status == WorklistStatus.Active
			}
		},
	})
	@Display($localize`:@@status:Status`)
	status: WorklistStatus;

	@Column({ name: 'client.displayName', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 170, showGtXl: true })
	@Display($localize`:@@client:Client`)
	clientId: number;

	@Column({ name: 'customer.number', filter: 'customer.number', filterOperator: '~', maxWidth: 85, showGtXl: true })
	@Display($localize`:@@customerNumber:Customer number`)
	customerId: number;

	@Column({ name: 'customer.displayName', filter: 'customer.displayName', maxWidth: 110, showGtXl: true })
	@Display($localize`:@@customer:Customer`)
	private customerName: number;

	@Column({ maxWidth: 75, filterOperator: '~', showGtXl: true })
	@Display($localize`:@@orderId:Order-ID`)
	orderId: number;

	@Column({ maxWidth: 75, filterOperator: '~', showGtXl: true })
	@Display($localize`:@@entryId:Entry-ID`)
	entryId: number;

	@Column({ shortDate: true, showGtXl: true })
	@Display($localize`:@@entryDate:Entry-Date`)
	entryDate: Date;

	resellerId: number;
	tariffId: string;
}